import React, { useEffect, useState } from 'react';
import S from 'StyledAccountFreebet.js';
import Loader from 'Loader.js';
import { useDispatch, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translation } from 'utilsHelper.js';
import _map from 'lodash/map';
import _size from 'lodash/size';
import _get from 'lodash/get';
import Pagination from 'Pagination.js';
import { formatDate } from 'datesHelper.js';
import { connect } from 'react-redux';
import {
  changeDateByType,
  fetchFreebetsByFilter,
  setCurrentPage,
  changeActiveTab,
  resetToInitialState,
} from 'accountFreebetActions.js';

const AccountFreebet = (props) => {
  const { isPending, activeTab, freebets, limit, currencyCode, startDate, endDate } = props;
  const activeFreebets = _get(freebets, 'active');
  const historyFreebets = _get(freebets, 'history');
  const activeFreebetsData = _get(activeFreebets, 'data');
  const historyFreebetsData = _get(historyFreebets, 'data');

  const dispatch = useDispatch();

  useEffect(() => {
    const datePickers = document.getElementsByClassName('react-datepicker__input-container');
    Array.from(datePickers).forEach((el) => el.childNodes[0].setAttribute('readOnly', true));

    fetchFreebets();

    return () => {
      const { resetToInitialState } = props;
      resetToInitialState();
    };
  }, []);

  const fetchFreebets = async () => {
    try {
      await dispatch(fetchFreebetsByFilter());
    } catch (error) {
      console.log('fetchFreebetByFilter:' + error);
    }
  };

  const onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchFreebetsByFilter } = props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchFreebetsByFilter();
    });
  };

  const handleChangeStart = (date) => {
    const { changeDateByType, fetchFreebetsByFilter } = props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchFreebetsByFilter();
    });
  };

  const handleChangeEnd = (date) => {
    const { changeDateByType, fetchFreebetsByFilter } = props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchFreebetsByFilter();
    });
  };

  const goPage = (currentPage) => {
    const { fetchFreebetsByFilter, setCurrentPage } = props;

    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchFreebetsByFilter();
      });
    } catch (error) {
      console.log('goPage:' + error);
    }
  };

  return (
    <S.AccountFreebet>
      <S.FreebetFilters className="freebet-filters">
        <S.FreebetFiltersBtns>
          <S.FilterBtn
            isActive={activeTab == 'active'}
            onClick={onChangeFilter.bind(this, 'active')}
          >
            {translation('account_freebets_activeFreebets')}
          </S.FilterBtn>

          <S.FilterBtn
            isActive={activeTab == 'history'}
            onClick={onChangeFilter.bind(this, 'history')}
          >
            {translation('account_freebets_historyFreebets')}
          </S.FilterBtn>
        </S.FreebetFiltersBtns>
        {activeTab == 'history' && (
          <S.FreebetFiltersDates className="freebet-filters-dates">
            <S.Datepicker>
              <div className="select-date"> {translation('account_wallet_selectDateFrom')}</div>
              <div className="icon"></div>
              <input
                type="date"
                value={formatDate(startDate, 'yyyy-MM-dd')}
                onChange={(event) => handleChangeStart(event.target.value)}
              />
            </S.Datepicker>
            <S.Datepicker>
              <div className="select-date"> {translation('account_wallet_selectDateTo')}</div>
              <div className="icon"></div>
              <input
                type="date"
                value={formatDate(endDate, 'yyyy-MM-dd')}
                onChange={(event) => handleChangeEnd(event.target.value)}
              />
            </S.Datepicker>
          </S.FreebetFiltersDates>
        )}
      </S.FreebetFilters>

      <S.FreebetList>
        {isPending ? (
          <Loader />
        ) : (
          <>
            {activeTab === 'active' && (
              <S.FreebetActiveList className="freebet-active-list">
                {activeFreebets ? (
                  <>
                    {_map(
                      activeFreebetsData,
                      ({ validTo, offerName, offerPlayerInfo, offerId, freebetStake, nameKey }) => {
                        offerPlayerInfo = offerPlayerInfo ?? {};
                        const { imageUrl = null, rulesPageUrl = null } = offerPlayerInfo;
                        return (
                          <S.FreebetRow key={offerId}>
                            <S.FreebetHeader data-translation={nameKey} className="freebetName">
                              {translation(nameKey)}
                            </S.FreebetHeader>
                            <S.FreebetBody>
                              <S.FreebetImageWrapper ratio={2}>
                                {imageUrl && <S.BonusOffrImg src={imageUrl}></S.BonusOffrImg>}
                              </S.FreebetImageWrapper>
                              <S.FreebetContent>
                                <S.FreebetBox>
                                  <S.FreebetTitle>
                                    {translation('account_freebet_offerId')}
                                  </S.FreebetTitle>
                                  <S.FreebetValue>{offerId}</S.FreebetValue>
                                </S.FreebetBox>
                                <S.Divider />
                                <S.FreebetBox>
                                  <S.FreebetTitle>
                                    {translation('account_freebet_freebetAmount')}
                                  </S.FreebetTitle>
                                  <S.FreebetValue>
                                    <span className="amount">{freebetStake.toFixed(2)}</span>&nbsp;
                                    <span className="currency">{currencyCode}</span>
                                  </S.FreebetValue>
                                </S.FreebetBox>
                                <S.Divider />
                                <S.FreebetBox>
                                  <S.FreebetTitle>
                                    {translation('account_freebet_expirationDate')}
                                  </S.FreebetTitle>
                                  <S.FreebetValue>
                                    {formatDate(validTo, 'yyyy.MM.dd HH:mm')}
                                  </S.FreebetValue>
                                </S.FreebetBox>
                              </S.FreebetContent>
                            </S.FreebetBody>

                            {rulesPageUrl && (
                              <S.FreebetFooter>
                                <S.FreebetRegulationLink href={rulesPageUrl}>
                                  {translation('account_freebet_regulationLink')}
                                </S.FreebetRegulationLink>
                              </S.FreebetFooter>
                            )}
                          </S.FreebetRow>
                        );
                      }
                    )}

                    {_size(activeFreebetsData) > 0 && (
                      <Pagination
                        currentPage={_get(activeFreebets, 'currentPage')}
                        limit={limit}
                        data={activeFreebetsData}
                        isNextPageAvailable={activeFreebets.isNextPageAvailable}
                        callback={goPage}
                      />
                    )}
                  </>
                ) : (
                  <S.NoResult>{translation('account_freebets_noActiveFreebets')}</S.NoResult>
                )}
              </S.FreebetActiveList>
            )}
            {activeTab === 'history' && (
              <S.FreebetHistoryList className="freebet-history-list">
                {_size(historyFreebetsData) ? (
                  <>
                    {_map(
                      historyFreebetsData,
                      ({ validTo, offerPlayerInfo, offerName, offerId, freebetStake, nameKey }) => {
                        offerPlayerInfo = offerPlayerInfo ?? {};
                        const { imageUrl = null, rulesPageUrl = null } = offerPlayerInfo;
                        return (
                          <S.FreebetRow key={offerId}>
                            <S.FreebetHeader data-translation={nameKey} className="freebetName">
                              {translation(nameKey)}
                            </S.FreebetHeader>
                            <S.FreebetBody>
                              <S.FreebetImageWrapper ratio={2}>
                                {imageUrl && <S.BonusOffrImg src={imageUrl}></S.BonusOffrImg>}
                              </S.FreebetImageWrapper>
                              <S.FreebetContent>
                                <S.FreebetBox>
                                  <S.FreebetTitle>
                                    {translation('account_freebet_offerId')}
                                  </S.FreebetTitle>
                                  <S.FreebetValue>{offerId}</S.FreebetValue>
                                </S.FreebetBox>
                                <S.Divider />
                                <S.FreebetBox>
                                  <S.FreebetTitle>
                                    {translation('account_freebet_freebetAmount')}
                                  </S.FreebetTitle>
                                  <S.FreebetValue>
                                    <span className="amount">{freebetStake.toFixed(2)}</span>&nbsp;
                                    <span className="currency">{currencyCode}</span>
                                  </S.FreebetValue>
                                </S.FreebetBox>
                                <S.Divider />
                                <S.FreebetBox>
                                  <S.FreebetTitle>
                                    {translation('account_freebet_expirationDate')}
                                  </S.FreebetTitle>
                                  <S.FreebetValue>
                                    {formatDate(validTo, 'yyyy.MM.dd HH:mm')}
                                  </S.FreebetValue>
                                </S.FreebetBox>
                              </S.FreebetContent>
                            </S.FreebetBody>

                            {rulesPageUrl && (
                              <S.FreebetFooter>
                                <S.FreebetRegulationLink href={rulesPageUrl}>
                                  {translation('account_freebet_regulationLink')}
                                </S.FreebetRegulationLink>
                              </S.FreebetFooter>
                            )}
                          </S.FreebetRow>
                        );
                      }
                    )}

                    {_size(historyFreebetsData) > 0 && (
                      <Pagination
                        currentPage={_get(historyFreebets, 'currentPage')}
                        limit={limit}
                        data={historyFreebetsData}
                        isNextPageAvailable={historyFreebets.isNextPageAvailable}
                        callback={goPage}
                      />
                    )}
                  </>
                ) : (
                  <S.NoResult>{translation('account_freebets_noHistoryFreebets')}</S.NoResult>
                )}
              </S.FreebetHistoryList>
            )}
          </>
        )}
      </S.FreebetList>
    </S.AccountFreebet>
  );
};

const mapStateToProps = (
  {
    AccountFreebet: { isPending, error, startDate, endDate, freebets, limit, activeTab },
    Auth: {
      user: { currencyCode },
    },
  },
  props
) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    freebets,
    limit,
    currencyCode,
    activeTab,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchFreebetsByFilter: bindActionCreators(fetchFreebetsByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
    resetToInitialState: bindActionCreators(resetToInitialState, dispatch),
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountFreebet);
